import data from './posts.json';
import resourceNotes from './resourceNotes.json';
import accounting from '../assets/images/accounting-hero-optimized.jpg';
import ethics from '../assets/images/ethics-hero-optimized.jpg';
export interface ArticleSource { label: string; url: string }
export interface ArticleSection {
 heading: string;
 paragraphs: string[];
 references?: ArticleSource[];
 table?: { headers: string[]; rows: string[][] };
}
export interface Post {
 slug: string; title: string; description: string; category: string;
 answer: string; updated: string; published?: string;
 sections: ArticleSection[]; sources: ArticleSource[];
 steps?: string[]; imageAlt?: string; imageCaption?: string; related?: string[];
}
export const posts: Post[] = [...data, ...resourceNotes];
const base = import.meta.env.BASE_URL;
const images: Record<string, { src: string; alt: string }> = {
 'ai-agents-vs-workflow-automation': { src: `${base}brand/social-kit/facebook-linkedin-landscape-post.png`, alt: 'AutomateHQ: connected workflows, custom software and practical AI' },
 'choosing-your-first-workflow': { src: `${base}photos/pexels-thirdman-7652245.jpg`, alt: 'Two colleagues discussing work on a laptop' },
 'accounting-finance-automation': { src: accounting, alt: 'A handwritten accounting ledger illustrating manual record keeping' },
 'ethics-of-ai-automation': { src: ethics, alt: 'Balance scales beside a laptop, illustrating judgement and accountability' },
};
const englishCover = (post: Post) => post.imageAlt ? { src: `${base}blog/editorial/${post.slug}.webp`, alt: post.imageAlt } : images[post.slug] || { src: `${base}blog/${post.slug}.svg`, alt: `${post.title}: workflow illustration` };
export const readTime = (post: Post) => Math.max(2, Math.ceil([post.answer, ...post.sections.flatMap(s => [s.heading, ...s.paragraphs, ...(s.table?.rows.flat() || [])])].join(' ').split(/\s+/).length / 200));

export const cover = (post: Post, thai = false) => {
 const image = englishCover(post);
 return thai ? { src: image.src.endsWith('.svg') ? image.src.replace('/blog/', '/blog/th/') : image.src, alt: post.imageAlt || `ภาพประกอบ: ${post.title}` } : image;
};
